"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var base_1 = require("./base");
function init() {
    return (0, base_1.initBase)();
}
exports.init = init;
